import React from 'react';
import{ Section } from 'components';

const Contact: React.FC = () => {
  return (
    <Section minHeight={250}>
      <h1>제휴 문의가 완료되었습니다. <br />빠른 시기 이내에 연락드리도록 하겠습니다.</h1>
      <a href={`/`}>홈으로 돌아가기</a>
    </Section>
  );
};

export default Contact;
